module.exports = __webpack_public_path__ + "img/success.e26460de.png";